import React from "react";
import "../../style/Contact.css";
import { toElement } from "../../utils/utils";
function Booking({ text }) {
  return <div className="booking-container body-b1">{toElement(text)}</div>;
}

export default Booking;
